import { getPresetDefinitionById } from '../business-logic/presets/getPresetDefinitionById'
import { addPageWithRepeater } from '../business-logic/dynamic-pages/add-page-with-repeater/addPageWithRepeater'
import { replaceDynamicPageCollection } from '../business-logic/dynamic-pages/replace-dynamic-page-collection/replaceDynamicPageCollection'
import {
  type EDITOR_TYPE,
  type AppApi,
  type Editor3DynamicPagesAppApi,
} from '@wix/wix-data-client-common'
import { updateDynamicPagePrefix } from '../business-logic/dynamic-pages/update-dynamic-page-prefix/updateDynamicPagePrefix'
import type {
  EditorSDK,
  FedopsLogger,
  I18n,
} from '@wix/wix-data-client-common-standalone'
import type { CollectionsApi } from '@wix/wix-code-collections-api'
import type { HttpClient } from '@wix/http-client'
import { addBlankDynamicPageEditor3 } from '../business-logic/dynamic-pages/add-blank-dynamic-page-editor3/addBlankDynamicPageEditor3'
import { addDynamicItemPage } from '../business-logic/dynamic-pages/add-dynamic-item-page/addDynamicItemPage'
import { convertPageToDynamicEditor3 } from '../business-logic/dynamic-pages/convert-page-to-dynamic-editor3/convertPageToDynamicEditor3'

type Params = {
  editorSdkProxy: EditorSDK
  finalAppApiPromise: Promise<AppApi>
  collectionsApi: CollectionsApi
  i18n: I18n
  fedopsLogger: FedopsLogger
  httpClient: HttpClient
  editorType: EDITOR_TYPE
}

export const getEditor3Api = ({
  editorSdkProxy,
  finalAppApiPromise,
  collectionsApi,
  i18n,
  fedopsLogger,
  httpClient,
  editorType,
}: Params): Editor3DynamicPagesAppApi => {
  return {
    // Note: This method expects the router to have a single route
    async replaceDynamicPageCollection({
      pageRef,
      newCollectionId,
      newRouterPrefix,
      fieldMap,
    }) {
      return replaceDynamicPageCollection({
        pageRef,
        newCollectionId,
        newRouterPrefix,
        fieldMap,
        editorSdkProxy,
        collectionsApi,
        appApi: await finalAppApiPromise,
        httpClient,
        i18n,
        fedopsLogger,
      })
    },

    // Note: This method expects the router to have a single route
    async updateDynamicPagePrefix({ pageRef, prefix }) {
      return updateDynamicPagePrefix({
        editorSdkProxy,
        appApi: await finalAppApiPromise,
        pageRef,
        prefix,
      })
    },

    async getPresetDefinitionById({ presetId }) {
      return getPresetDefinitionById(presetId, editorType, editorSdkProxy)
    },

    async addPageWithRepeater({ preset, collectionName }) {
      return addPageWithRepeater({
        editorSdkProxy,
        preset,
        collectionName,
      })
    },

    async addDynamicItemPage({ preset, schema }) {
      return addDynamicItemPage({
        editorSdkProxy,
        appApi: await finalAppApiPromise,
        preset,
        schema,
        editorType,
      })
    },

    addBlankDynamicPageEditor3: async ({ collectionId }) => {
      return addBlankDynamicPageEditor3({
        editorSdkProxy,
        collectionsApi,
        appApi: await finalAppApiPromise,
        collectionId,
      })
    },

    convertPageToDynamicEditor3: async ({ pageRef, schema }) => {
      return convertPageToDynamicEditor3({
        editorSdkProxy,
        appApi: await finalAppApiPromise,
        pageRef,
        schema,
      })
    },
  }
}
